var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMounted)?_c('div',{key:_vm.route,staticClass:"loader"},[(_vm.dataReady)?_c('div',{staticClass:"vx-row"},_vm._l((_vm.settings.data),function(fName,fIndex){return _c(fName.type,{key:fIndex,tag:"component",attrs:{"index":fIndex,"settings":fName}})}),1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }